import * as tslib_1 from "tslib";
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import { updateUserConfiguration } from 'owa-options-core';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveInlinePreviewsOption')(function saveInlinePreviewsOption(isEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, isFeatureEnabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    isFeatureEnabled = isEnabled === void 0 ? optionState.isEnabled : isEnabled;
                    userOptions.ShowInlinePreviews = isFeatureEnabled;
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'ShowInlinePreviews',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowInlinePreviews,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveInlinePreviewsOption.js.map